module.exports = __webpack_public_path__ + "images/harry_goodnight.jpg?v=cf8d3ec7d0df553b44dfffb61fb72d1d";